import { RefString, RefNumber } from "@tblabs/truffle";
import { RawProductOption } from "./RawProductOption";


export class ProductOption
{
    public Url = new RefString(); // This is also an ID
    public Label = new RefString();
    public Description = new RefString();
    public PriceFactor = new RefNumber(); // For example 1.25 for 25% more expensive

    constructor(raw?: Partial<RawProductOption>)
    {
        this.Url.value = raw?.Url || "";
        this.Label.value = raw?.Label || "";
        this.Description.value = raw?.Description || "";
        this.PriceFactor.value = raw?.PriceFactor || 1;
    }

    public static get Default(): ProductOption
    {
        return new ProductOption({ Url: "opcja-domyslna", Label: "", Description: "Opcja domyślna", PriceFactor: 1 });
    }
}
